import { defineStore } from 'pinia';

// AI Playback (SW-6793): live, unpersisted skip counters for the current
// playback session. The Skip Filler Words / Skip Silences toggles themselves
// are server-persisted item data — see useAiMetadataStore — since the
// owner's choice is what everyone's playback (owner or guest) respects, not
// a per-viewer preference.
export interface AiPlaybackState {
  fillerWordsSkipped: number;
  silenceSecondsSkipped: number;
}

export const useAiPlaybackStore = defineStore('aiPlaybackStore', {
  state: (): AiPlaybackState => ({
    fillerWordsSkipped: 0,
    silenceSecondsSkipped: 0,
  }),
  actions: {
    recordFillerWordSkipped() {
      this.fillerWordsSkipped += 1;
    },
    recordSilenceSkipped(seconds: number) {
      this.silenceSecondsSkipped += seconds;
    },
    // The counters aren't rendered anywhere today (see PR description), but
    // they're what the skip-detection logic itself relies on — reset them
    // whenever the viewed item changes so they don't accumulate across every
    // video watched in a session.
    resetForNewItem() {
      this.fillerWordsSkipped = 0;
      this.silenceSecondsSkipped = 0;
    },
  },
});
